module.exports = __webpack_public_path__ + "static/media/portfolio-img4.95000ac2.JPG";